/**
 * 選定解除対象情報取得VOクラス
 */
export class GetDeletePlanGoodsInfoModel {
  public orderCode = '';
  public pCode = '';
  public mediumType = '';
}
